<div class="manage-users-page">
  <div *ngIf="displayRoleMatrix">
    <vs-role-matrix
      (closeRolesMatrixEvent)="closeRolesMatrixOverlay($event)"
    ></vs-role-matrix>
  </div>
  <div class="top-header"></div>
  <div id="successMessage" *ngIf="showSuccessMessage">
    <div class="container-fluid row container-success">
      <div class="col-md-12 popup-msg-border">
        <i class="custom-icon success" *ngIf="!isDisablingUser"></i>
        <i class="custom-icon alert-error" *ngIf="isDisablingUser"></i>
        <div class="error-text edit-text" *ngIf="!isDisablingUser">
          <h4 class="success-pending-header">
            {{ "userManagement.successHeader" | cxTranslate }}
          </h4>
          <p class="error-pending-msg">
            {{ "userManagement.successMsg" | cxTranslate }}
          </p>
        </div>
        <div class="error-text" *ngIf="isDisablingUser">
          <h4 class="success-pending-header">
            {{ "userManagement.errorHeader" | cxTranslate }}
          </h4>
          <p class="error-pending-msg">
            {{ "userManagement.disableMsg" | cxTranslate }}
          </p>
        </div>
        <i
          (click)="showSuccessMessage = false"
          class="material-icons custom-clear-icon"
          >clear</i
        >
      </div>
    </div>
    <!--success msg ends-->
  </div>
  <!-- <p class="tb-parent mngText">
  {{ "userManagement.manageParagraph" | cxTranslate }} 
  <a [routerLink]="['/contactus']" [queryParams]="{page: 'manage-user'}">{{ "userManagement.cstmrCareText" | cxTranslate }}</a>
</p> -->

  <div class="example-container tb-parent">
    <div class="user-table-header">
      <span class="header-text mt-1">{{ "userManagement.userList" | cxTranslate }}</span>
      <div class="header-action">
        <i class="material-icons" (click)="openRoleMatrix()">info</i>
        <!-- Hidden until OKTA implementation -->
        <button class="vs-tertiary-btn" (click)="redirectToRegister()">
          {{ "userManagement.regNewUser" | cxTranslate }}
        </button>
      </div>
    </div>
    <mat-table #table [dataSource]="dataSource">
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef class="tb-heading cutomeNameWidth">
          {{ "userManagement.nameHeader" | cxTranslate }}
          <em
            class="material-icons info help_header"
            matTooltip='{{"userManagement.requestTooltipTxt" | cxTranslate }}'
            matTooltipClass="vs-tooltip-custom"
            matTooltipPosition="above"
            >info</em
          >
          <!-- <div class="ml-20">
        <div (click)="toggleSort(true)">
          <i  class="material-icons open-icon top-icon arrow">{{ "userManagement.arrowUpIcon" | cxTranslate }}</i>
        </div>
        <div (click)="toggleSort(false)">
          <i  class="material-icons open-icon arrow">{{ "userManagement.arrowDownIcon" | cxTranslate }}</i> 
        </div>
      </div> -->
        </mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          class="tb-content cutomeNameWidth pointer"
          [ngClass]="{
            rowClick: editClick == element.name,
            'role-change': element.requestedForRoleChange !== null
          }"
        >
          <!-- (click)="navigateToUser(element)" -->
          <span class="avtar">{{ element?.shortName }}</span
          >{{ element.name }}
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="uid">
        <mat-header-cell *matHeaderCellDef class="tb-heading cutomeUserWidth">
          {{ "userManagement.userNameHeader" | cxTranslate }}</mat-header-cell
        >
        <mat-cell
          *matCellDef="let element"
          class="tb-content cutomeUserWidth"
          [ngClass]="{ rowClick: editClick == element.name }"
        >
          {{ element.uid }}
        </mat-cell>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef class="tb-heading customeEmail">
          {{
            "userManagement.emailAddressHeader" | cxTranslate
          }}</mat-header-cell
        >
        <mat-cell
          *matCellDef="let element"
          class="tb-content customeEmail"
          [ngClass]="{ rowClick: editClick == element.name }"
        >
          {{ element.email }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="roles">
        <mat-header-cell *matHeaderCellDef class="tb-heading customeRoleWidth">
          {{ "userManagement.roleHeader" | cxTranslate }}</mat-header-cell
        >
        <mat-cell
          *matCellDef="let element"
          class="tb-content customeRoleWidth"
          [ngClass]="{ rowSelcted: editClick == element.name }"
        >
          <div *ngIf="!hideContent" class="tb-content">
            <span>{{ element.role }}</span>
            <em
              matTooltipClass="vs-tooltip capitalize"
              matTooltip="{{ element.roleDescription }}"
              class="material-icons customeTool help"
              >info</em
            >
          </div>
          <div
            *ngIf="hideContent && editClick != element.name"
            class="tb-content"
          >
            <span>{{ element.role }}</span>
            <em
              matTooltipClass="vs-tooltip capitalize"
              matTooltip="{{ element.roleDescription }}"
              class="material-icons customeTool help"
              >info</em
            >
          </div>
          <div *ngIf="editClick == element.name" class="roles vs-radio-button">
            <form>
              <div
                *ngFor="
                  let userRole of element.manageUserRoleList;
                  let j = index
                "
              >
                <input
                  [id]="userRole?.code"
                  type="radio"
                  [value]="userRole?.code"
                  [checked]="userRole?.selected === true ? true : false"
                  name="role"
                  (change)="onRoleChange(userRole, $event.target.value)"
                />
                <label [for]="userRole?.code" class="tb-content"
                  >{{ userRole?.name }}<br />
                  <span class="role-txt">{{ userRole?.description }}</span>
                </label>
              </div>
            </form>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell
          *matHeaderCellDef
          class="tb-heading status customeStatusWidth"
        >
          {{ "userManagement.statusHeader" | cxTranslate }}</mat-header-cell
        >
        <mat-cell
          *matCellDef="let element"
          class="tb-content customeStatusWidth"
          [ngClass]="{ rowClick: editClick == element.name }"
        >
          <span *ngIf="!hideContent" class="tb-content"
            >{{ element.status }}

            <i
              *ngIf="element.status == 'Disabled'"
              matTooltipClass="vs-tooltip capitalize"
              matTooltip="{{ element.status }} status"
              class="material-icons customeTool help"
              >info</i
            >
          </span>
          <span
            *ngIf="hideContent && editClick != element.name"
            class="tb-content"
            style="display: flex"
            >{{ element.status }}
            <i
              *ngIf="element.status == 'Disabled'"
              matTooltipClass="vs-tooltip capitalize"
              matTooltip="{{ element.status }} status"
              class="material-icons customeTool help"
              >info</i
            >
          </span>
          <div *ngIf="editClick == element.name" class="vs-radio-button status">
            <form>
              <div class="radio-status">
                <input
                  id="active"
                  type="radio"
                  value="Active"
                  [checked]="element.status == 'Active'"
                  name="status"
                  [(ngModel)]="element.status"
                  (change)="onStatusChange(element, $event.target.value)"
                />
                <label for="active" class="tb-content">{{
                  "userManagement.activeLabel" | cxTranslate
                }}</label>
              </div>
              <div>
                <input
                  id="disabled"
                  type="radio"
                  value="Disabled"
                  [checked]="element.status == 'Disabled'"
                  name="status"
                  [(ngModel)]="element.status"
                  (change)="onStatusChange(element, $event.target.value)"
                />
                <label for="disabled" class="tb-content"
                  >{{ "userManagement.disableLabel" | cxTranslate }}
                  <br />
                  <span class="role-txt">
                    {{ "userManagement.diableTextMsg" | cxTranslate }}
                  </span>
                </label>
              </div>
            </form>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell
          *matHeaderCellDef
          class="tb-heading customeActionWidth"
        >
          {{ "userManagement.actionHeader" | cxTranslate }}</mat-header-cell
        >
        <mat-cell
          *matCellDef="let element"
          class="customeActionWidth"
          [ngClass]="{ rowClick: editClick == element.name }"
        >
          <i
            *ngIf="!hideContent && element.status != 'Disabled'"
            (click)="edit(element.name)"
            class="material-icons editIcon"
            >mode_edit</i
          >
          <i
            *ngIf="
              hideContent &&
              editClick != element.name &&
              element.status != 'Disabled'
            "
            (click)="edit(element.name)"
            class="material-icons editIcon"
            >mode_edit</i
          >
          <span *ngIf="hideContent && editClick == element.name">
            <i (click)="closeRow(element)" class="material-icons">clear</i>
            <i (click)="submitData(element)" class="material-icons">check</i>
          </span>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let element; columns: displayedColumns"
        [ngClass]="{ rowSelcted: editClick == element.name }"
      ></mat-row>
    </mat-table>
  </div>
</div>
